import React from 'react';
import PropTypes from 'prop-types';
import keygen from '~helpers/keygen';

export default function CheckIcon({ width = 16, height = 16, color = '#3C3C40' }) {
  const key = keygen();

  return (
    <svg
      role="img"
      aria-labelledby={`checkIcon_${key}`}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={`checkIcon_${key}`}>check icon</title>
      <path
        d="M12.4663 4.8C12.1997 4.53333 11.7997 4.53333 11.533 4.8L6.53301 9.8L4.46634 7.73333C4.19967 7.46667 3.79967 7.46667 3.53301 7.73333C3.26634 8 3.26634 8.4 3.53301 8.66667L6.06634 11.2C6.19967 11.3333 6.33301 11.4 6.53301 11.4C6.73301 11.4 6.86634 11.3333 6.99967 11.2L12.4663 5.73333C12.733 5.46667 12.733 5.06667 12.4663 4.8Z"
        fill={color}
      />
    </svg>
  );
}

CheckIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
